import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 96 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M13.6875 59.8671V15.8672H51.6875\" stroke=\"#C61736\" stroke-width=\"3\"></path><path d=\"M5.6875 91.8672L13.6875 59.8672H77.6875L85.6875 91.8672H5.6875Z\" stroke=\"#C61736\" stroke-width=\"3\"></path><path d=\"M36.6875 77.8672H54.6875\" stroke=\"#C61736\" stroke-width=\"3\"></path><path d=\"M77.6914 59.8943V39.8672\" stroke=\"#C61736\" stroke-width=\"3\"></path><path d=\"M93.0781 2.86328L61.0781 34.8633M93.0781 34.8633L61.0781 2.86328\" stroke=\"#C61736\" stroke-width=\"3\"></path>", 5)
  ])))
}
export default { render: render }